(<template>
  <div class="finish-actions">
    <div class="finish-actions__button-wrapper">
      <a v-if="supportPortalLink"
         :href="supportPortalLink"
         class="sk-btn sk-btn--white finish-actions__btn"
         target="_blank">{{ $gettext('Frequently asked questions') }}</a>
    </div>
  </div>
</template>)

<script>
  export default {
    data() {
      return {
        supportPortalLink: this.$getString('domainData', 'supportPortalLink')
      };
    }
  };
</script>

<style scoped>
  .finish-actions {
    display: flex;
    margin-top: 30px;
  }

  .finish-actions__button-wrapper {
    display: block;
    width: 100%;
    max-width: 265px;
  }

  @media (max-width: 767px) {
    .finish-actions {
      flex-wrap: wrap;
    }

    .finish-actions__button-wrapper {
      max-width: 100%;
    }
  }
</style>
